import { aschehougOidcClient } from '@/main'
import { i18n } from '../../translations'
import { router } from '@/router'

const { VITE_AM_CORE, VITE_API_CORE, VITE_CONTENT_API_URL, VITE_CORE_EXTERNAL_API_URL, VITE_CMS_REST_API } = import.meta.env

const vgsFetch = (
  baseUrl: string,
  isAuthorizedRequest = true,
  isJsonResponse = true
) => async (path: string, { method = 'GET', headers, ...options }: RequestInit = {}) => {
  const isContentOrCmsRestApi = baseUrl === VITE_CONTENT_API_URL || baseUrl === VITE_CMS_REST_API
  const isExternalCoreApi = baseUrl === VITE_CORE_EXTERNAL_API_URL

  const requestHeaders = new Headers({
    Accept: 'application/json',
    ...(isContentOrCmsRestApi && {
      'X-Siteaccess': (i18n.global.locale as any).value,
      Accept: import.meta.env.VITE_HEADER_ACCEPT,
    }),
    ...(isExternalCoreApi && {
      'Content-Type': 'application/json',
    }),
    ...(isAuthorizedRequest && { Authorization: `Bearer ${aschehougOidcClient.getAccessToken()}` }),
    ...headers
  })

  if (!requestHeaders.get('Content-type')) {
    requestHeaders.append('Content-type', import.meta.env.VITE_HEADER_CONTENT_TYPE)
  }

  const response = await fetch(baseUrl + path, {
    method,
    headers: requestHeaders,
    ...options
  })

  if (!isJsonResponse) {
    return response
  }

  const data = await response.json()


  if(response.status === 404) {
    await router.push('/404')
  }

  if (!response.ok) throw new Error(data.message || response.statusText)



  return data
}

export const fetchAmCore = vgsFetch(VITE_AM_CORE)
export const fetchCore = vgsFetch(VITE_API_CORE, false)
export const fetchFile = vgsFetch(VITE_CONTENT_API_URL, true, false)
export const fetchContent = vgsFetch(VITE_CONTENT_API_URL)
export const fetchCoreExternal = vgsFetch(VITE_CORE_EXTERNAL_API_URL)

export const fetchCmsRest = vgsFetch(VITE_CMS_REST_API)
